export async function fetchApi(url) {
  return await fetch(url).then(function (response) {
    return response.json();
  }).then(function (data) {
    return data;  
  });
}